import * as TYPES from "./types";

export function changeLanguage(payload = "en") {
    return {
        type: TYPES.INTERNALIZATION_CHANGE_LANGUAGE,
        payload,
    };
}

export function loadLanguage(payload = {}) {
    return {
        type: TYPES.INTERNALIZATION_LOAD_CONFIGURATION,
        payload,
    };
}
